<template>
	<div>
		<div>
			<div v-if="value.ícono && value.ícono.identificador" class="contenedor-objetos">
				<figure v-html="svgÍcono"></figure>
				<div class="telon text-center">
					<v-btn fab @click.stop="seleccionar()">
						<v-icon dark>mdi-pencil</v-icon>
					</v-btn>
				</div>
			</div>
			<div v-else class="medio-vacio">
				<v-btn fab @click.stop="seleccionar()" title="Agregar ícono">
					<v-icon dark>mdi-plus</v-icon>
				</v-btn>
			</div>
		</div>

		<v-dialog
      v-model="selección"
      max-width="1000"
			persistent
			scrollable
    >
      <IconosSeleccion
				v-model="value.ícono"
				@finalizar="selección = false"
				@cancelar="selección = false"
			></IconosSeleccion>
    </v-dialog>
	</div>
</template>

<script>
import IconosSeleccion from '@/components/IconosSeleccion.vue'
import iconosContorneados from '@/components/iconosContorneados'
import iconosSolidos from '@/components/iconosSolidos'

export default {
	name: 'ParteIcono',

	data: () => ({
		iconosContorneados: iconosContorneados,
		iconosSolidos: iconosSolidos,
		selección: false
	}),

	components: {
		IconosSeleccion
	},

	props: {
		value: {
			type: Object,
			required: true
		},
	},

	computed: {
		svgÍcono: function() {
			let svg = ''
			if (this.value.ícono && this.value.ícono.estilo === 'contorneado') {
				svg = this.iconosContorneados.get(this.value.ícono.identificador)
			} else if (this.value.ícono && this.value.ícono.estilo === 'sólido') {
				svg = this.iconosSolidos.get(this.value.ícono.identificador)
			}

			return svg || ''
		}
	},

	methods: {
		seleccionar() {
			this.selección = true
		}
	}
}
</script>